import { ReactNode } from 'react';

import * as LDClient from 'launchdarkly-js-client-sdk';
import { LDProvider as LDProviderComponent, useFlags } from 'launchdarkly-react-client-sdk';

import { webVersion } from 'utils/app-version-info';
import { getApiKey, region } from 'utils/environment';

import { WAIT_FOR_LD_TIMEOUT_SECONDS, privateAttributes } from './constants';
import safeFlagDefaults from './safe-flag-defaults';

const WEB_API_KEY = getApiKey({ key: 'launchDarkly' });

export let ldClient: LDClient.LDClient | null;

export const configurePlatformClient = async (ldUserAttributes: LDClient.LDContext) => {
  ldClient = LDClient.initialize(WEB_API_KEY, ldUserAttributes, {
    privateAttributes,
    bootstrap: 'localStorage',
    application: {
      id: `bk-${region.toLowerCase()}-app-web`,
      version: webVersion,
    },
  });

  await ldClient.waitForInitialization(WAIT_FOR_LD_TIMEOUT_SECONDS);
};

export const getAllFlags = () => {
  const flags = ldClient?.allFlags();
  return flags && Object.keys(flags).length > 0 ? flags : safeFlagDefaults;
};

export const launchDarklyIdentify = async (
  ldUserAttributes: LDClient.LDContext,
  _waitForNetworkResults = true
) => ldClient?.identify(ldUserAttributes);

export function LDProvider(props: { children: ReactNode }) {
  return (
    // @ts-expect-error - clientSideID required (but it really isn't if you pass the LDClient)
    <LDProviderComponent
      ldClient={ldClient ?? undefined}
      reactOptions={{ useCamelCaseFlagKeys: false }}
      {...props}
    />
  );
}

export const useFlagCore = (name: string, defaultValue: any) => {
  const flags = useFlags();
  return flags[name] ?? defaultValue;
};
